module.exports = "<body>\n    <router-outlet>\n\n    </router-outlet>\n  </body>"